import type { CategoryCenteredItem } from '@/pages/CategoryPage/CategoryPage.types';

export const ALL_PRODUCT_BOX: CategoryCenteredItem = {
  id: 0,
  name: 'All Products',
  slug: 'all',
  iconUrl: '/images/category/all_pro.webp',
  ctaUrl: '',
};

export const ALL = 'all';

export const SCROLL_HIDE_HEADER_THRESHOLD = 32;

export const SCROLL_LOAD_MORE_THRESHOLD = 100;
export const LAST_ITEMS_LOAD_MORE_THRESHOLD = 200;
export const ITEMS_UNTIL_LOAD_MORE = 8;
